<div class="odd" [class.specials]="specials" *transloco="let t">
  <p class="name" [class.is-text-longer]="longSelecionName(odd?.selectionName)">{{ t(odd?.selectionName) }}</p>
  <p class="value" *ngIf="odd && odd.value !== 1; else missingOdd">{{ odd.value | formatOdd }}</p>
</div>

<ng-template #missingOdd>
  <p class="value missing">-</p>
</ng-template>
